
import { defineComponent, computed, ref, toRef, watch } from "vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
// import { useForm } from "vee-validate";
import { Field, ErrorMessage } from "vee-validate";
// import * as Yup from "yup";

import ApiService from "@/core/services/ApiService";
import { DrawerComponent } from "@/assets/ts/components/_DrawerComponent";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

interface CardHolder {
  email: string;
  phone: string;
  full_name: string;
  last_name: string;
  first_name: string;
  billing_address: string;
  shipping_address: string;
  customer_id: string;
  ip_address: string;
}

interface ProductDetails {
  product_name: string;
  product_category: string;
  product_description: string;
  product_url: string;
  product_price: string;
  order_id: string;
  delivered: string;
  image_url: string;
  order_amt: string;
  sales_tax: string;
  total_amt: string;
  product_id: string;
  description: string;
  ship_carrier: string;
  delivered_date: string;
  tracking_number: string;
}

interface OrderDetailsItem {
  productId: string;
  product_url: string;
  name: string;
  price: string;
  qty: string;
  product_description: string;
  purchaseId: string;
  orderItemId: string;
}

export default defineComponent({
  name: "view_incoming_details_drawer",
  emit: ["submit"],
  components: {
    Field,
    ErrorMessage,
    flatPickr,
  },
  props: {
    incomingData: { type: Object, required: true },
  },
  data() {
    return {
      componentKey: 0,
      // Get more form https://flatpickr.js.org/options/
      config: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: "M j, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
    };
  },
  setup(props, { emit }) {
    const submitButton = ref<HTMLButtonElement | null>(null);
    const incoming = toRef(props, "incomingData");
    const activeNames = ref([]);

    watch(
      () => incoming.value,
      async () => {
        activeNames.value.splice(0);
      }
    );

    const cardHolder = ref<CardHolder>({
      email: "",
      phone: "",
      full_name: "",
      last_name: "",
      first_name: "",
      billing_address: "",
      shipping_address: "",
      customer_id: "",
      ip_address: "",
    });

    const productDetails = ref<ProductDetails>({
      product_name: "",
      product_category: "",
      product_description: "",
      product_url: "",
      product_price: "",
      order_id: "",
      delivered: "",
      image_url: "",
      order_amt: "",
      sales_tax: "",
      total_amt: "",
      product_id: "",
      description: "",
      ship_carrier: "",
      delivered_date: "",
      tracking_number: "",
    });

    const orderDetailsItem = ref<OrderDetailsItem>({
      productId: "",
      product_url: "",
      name: "",
      price: "",
      qty: "",
      product_description: "",
      purchaseId: "",
      orderItemId: "",
    });

    const getChargebackDetails = computed(() => {
      var transaction_date = incoming.value.transaction_date;
      if (
        transaction_date == "0000-00-00" ||
        transaction_date == "0000-00-00 00:00:00"
      ) {
        transaction_date = "";
      }
      var refund_date = incoming.value.transaction_date;
      if (refund_date == "0000-00-00" || refund_date == "0000-00-00 00:00:00") {
        refund_date = "";
      }
      return {
        settled_amount: incoming.value.settled_amount,
        transaction_date: transaction_date,
        is_refunded: incoming.value.is_refunded,
        refund_date: refund_date,
      };
    });

    const getProductDetails = computed(() => {
      Object.keys(productDetails.value).forEach((key) => {
        if (incoming.value.product_details[key]) {
          productDetails.value[key] = incoming.value.product_details[key];

          if (
            incoming.value.product_details[key] == "0000-00-00" ||
            incoming.value.product_details[key] == "0000-00-00 00:00:00"
          ) {
            productDetails.value[key] = "";
          }
        }
      });

      return productDetails.value;
    });

    const getCardHolder = computed(() => {
      Object.keys(cardHolder.value).forEach((key) => {
        if (incoming.value.card_holder[key]) {
          cardHolder.value[key] = incoming.value.card_holder[key];
        }
      });

      return cardHolder.value;
    });

    const getOrderDetailsItem = computed(() => {
      const orderItems = incoming.value.order_details.items || [];
      if (orderItems.length > 0) {
        Object.keys(orderDetailsItem.value).forEach((key) => {
          if (orderItems[0][key]) {
            orderDetailsItem.value[key] = orderItems[0][key];
          }
        });
      }

      return orderDetailsItem.value;
    });

    const formSubmit = async () => {
      // eslint-disable-next-line
      submitButton.value!.disabled = true;
      // Activate indicator
      submitButton.value?.setAttribute("data-kt-indicator", "on");

      // eslint-disable-next-line
      const payload: any = {
        ...getChargebackDetails.value,
        card_holder: getCardHolder.value,
        product_details: getProductDetails.value,
        order_details: getOrderDetailsItem.value,
      };

      console.log(payload);

      try {
        const res = await ApiService.put(
          `chargebacks/incoming/${incoming.value.id}`,
          payload
        );
        if (res.data.success) {
          Swal.fire({
            text: "You have successfully Saved the incoming!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(async function () {
            DrawerComponent?.getInstance(
              "view_incoming_details_drawer"
            )?.hide();
            emit("submit");
          });
        } else {
          Swal.fire({
            text: res.data.error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }

      submitButton.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
      submitButton.value!.disabled = false;
    };

    return {
      incoming,
      getChargebackDetails,
      getProductDetails,
      getCardHolder,
      getOrderDetailsItem,
      activeNames,
      submitButton,
      formSubmit,
    };
  },
});
